/**
 * Main Entry Point
 *
 * Application bootstrap
 */

import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import { ProveedorDeTema } from './application/tema/tema.context'
import './styles/globals.css'

// Get root element
const rootElement = document.getElementById('root')

if (!rootElement) {
  throw new Error('Root element not found')
}

// Create React root and render
createRoot(rootElement).render(
  <StrictMode>
    <ProveedorDeTema>
      <App />
    </ProveedorDeTema>
  </StrictMode>
)
